import { render, staticRenderFns } from "./PlanCreateFail.vue?vue&type=template&id=46fb91e6&scoped=true"
import script from "./PlanCreateFail.vue?vue&type=script&lang=js"
export * from "./PlanCreateFail.vue?vue&type=script&lang=js"
import style0 from "./PlanCreateFail.vue?vue&type=style&index=0&id=46fb91e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb91e6",
  null
  
)

export default component.exports